import * as React from "react";
import { ModalComponent } from "../ModalComponent";
import {default as CTA, CTATheme} from "../common/CallToAction";

interface IBtnDisplayProps {
    text: string;
    clickHandler: () => void;
    styles?: React.CSSProperties;
}

interface IAlertModalProps {
    cancelBtnProps?: IBtnDisplayProps;
    primaryBtnProps?: IBtnDisplayProps;
    header: React.ReactNode;
    body: React.ReactNode;
}

interface IAlertModalState {

}



export class AlertModal extends React.Component<IAlertModalProps, IAlertModalState> {
    constructor(props: IAlertModalProps) {
        super(props);
    }

    render() {
        const { cancelBtnProps, primaryBtnProps, body, header } = this.props;
        return (
            <ModalComponent modalSize="small">
                <div className="roster-modal-container alert-modal" onClick={(e) => { e.stopPropagation(); e.preventDefault() }}>
                    <div className="roster-modal-header alert-modal">{header}</div>
                    <hr></hr>
                    <div className="roster-modal-body alert-modal">{body}</div>
                    <hr></hr>
                    <div className="roster-modal-footer alert-modal">
                        {cancelBtnProps &&
                            <button className="primary-action-btn" style={cancelBtnProps.styles}
                                onClick={cancelBtnProps.clickHandler}>{cancelBtnProps.text}</button>
                        }
                        {primaryBtnProps &&
                        <CTA innerText={primaryBtnProps.text} theme={CTATheme.PRIMARY}
                             onClick={primaryBtnProps.clickHandler}
                             customStyle={{display: "inline", fontSize: 14, padding: "10px 50px"}}/>
                        }
                    </div>
                </div>
            </ModalComponent >
        )
    }

}

